class Lists extends HTMLElement {
  constructor() {
    super();

    this.predefinedLists = this.handlePredefinedLists.bind(this)() || {};
    this.defaultLists = Object.keys(this.predefinedLists);
    this.currentLists = [];
    this.currentProduct = null;
    this.checkedLists = [];

    this.dialog = this.querySelector('[data-modal-dialog]');
    this.listsPlaceholder = this.querySelector('[data-lists-placeholder]');
    this.productPlaceholder = this.querySelector('[data-product-placeholder]');
    this.addToListsBtn = this.querySelector('[data-add-to-list-button]');
    this.createListFormToggleBtns = this.querySelectorAll('[data-toggle-create-list-form]');
    this.createListForm = this.querySelector('.create-list-form');
    this.footer = this.querySelector('.lists-modal__footer');
    this.createListBtn = this.querySelector('[data-create-list]');
    this.closeModalBtn = this.querySelector('[data-close-modal-button]');
    this.modalBtns = this.querySelector('.pd-modal__buttons');

    this.createLists = this.createLists.bind(this);
    this.removeAllLists = this.removeAllLists.bind(this);
    this.renderLists = this.renderLists.bind(this);
    this.open = this.open.bind(this);
    this.close = this.close.bind(this);
    this.checkList = this.checkList.bind(this);
    this.updateLists = this.updateLists.bind(this);
    this.uncheckAllCheckboxes = this.uncheckAllCheckboxes.bind(this);
    this.enableLoading = this.enableLoading.bind(this);
    this.disableLoading = this.disableLoading.bind(this);
    this.updateIconsStatus = this.updateIconsStatus.bind(this);
    this.removeList = this.removeList.bind(this);

    document.querySelectorAll('[data-add-to-lists-button]')?.forEach(button => {
      button.addEventListener('click', () => this.open(button));
    });

    /*
      Initialize wishlist buttons for Searchspring rendered results
      Note: This will run anytime the event "ss-dom-ready" is emitted(when SS results have changed/re-rendered)
    */
    window.addEventListener('ss-dom-ready', () => {
      document.querySelectorAll('[data-add-to-lists-button]')?.forEach(button => button.addEventListener('click', () => this.open(button)))
      this.updateIconsStatus();
    })

    document.addEventListener('trigger::addToLists', e => {
      const button = e.detail?.button;
      if (!button) return;
      this.open(button);
    })

    document.addEventListener('trigger::initLists', e => {  
      this.updateIconsStatus();
    })

    document.addEventListener('click', (e) => {
      if (this.dialog && this.contains(e.target) && !this.dialog.contains(e.target)) {
        this.close();
      }
    })

    this.closeModalBtn?.addEventListener('click', this.close);

    this.createListFormToggleBtns?.forEach(button => {
      button.addEventListener('click', this.toggleCreateListForm.bind(this));
    })

    this.createListBtn?.addEventListener('click', this.createList.bind(this));

    this.addToListsBtn?.addEventListener('click', () => {
      const self = this;
      const listItemMap = self.currentProduct;
      const listIds = self.checkedLists;

      function swymCallbackFn(swat) {
        self.enableLoading(self);
        swat.addProductToLists(listItemMap, listIds, function(resp){
          self.checkedLists = [];
          self.uncheckAllCheckboxes();
          self.updateLists();
          self.close();
          document.dispatchEvent(new CustomEvent('lists::productAdded', {
            detail: {
              ...resp,
              numberOfLists: listIds.length,
              listsPageUrl: self.dataset.listsPageUrl
            }
          }))

          self.disableLoading(self);
        }, function(xhrObject) {
          self.disableLoading(self);
          // something went wrong
        });
      }
      if(!window.SwymCallbacks) {
        window.SwymCallbacks = [];
      }
      window.SwymCallbacks.push(swymCallbackFn);
    })
  }

  handlePredefinedLists() {
    let data = this.dataset.predefinedLists?.split('|');
    if (!data) return {};

    const result = {};
    data.forEach(item => {
      if (item) {
        const splittedItem = item.split(':');
        result[splittedItem[0]] = splittedItem[1] || '';
      }
    })

    return result;
  }

  toggleCreateListForm() {
    this.createListForm?.classList.toggle('hidden');
    this.footer?.classList.toggle('hidden');
    this.createListForm?.querySelector('input[name="newList"]').focus();

    this.modalBtns?.classList.toggle('hidden');
  }

  createList() {
    const listName = this.createListForm.querySelector('input[name="newList"]').value;
    if (!listName) return;
    const self = this;
    const newListDef = {
      lname: listName
    };

    function swymCallbackFn(swat) {
      self.enableLoading(self);
      swat.createList(newListDef, function(newListObj){
        self.updateLists();
        self.toggleCreateListForm.bind(self)();
      }, function(xhrObject) {
        // something went wrong
      });
    }
    if(!window.SwymCallbacks) {
      window.SwymCallbacks = [];
    }
    window.SwymCallbacks.push(swymCallbackFn);
  }

  updateLists() {
    var self = this;
    async function swymCallbackFn(swat) {
      swat.fetchLists({
        callbackFn: async (lists) => {
          self.currentLists = lists;
          const listsToCreate = [];
          self.defaultLists.forEach(lname => {
            if (!lists.find(l => l.lname === lname)) {
              listsToCreate.push({ lname });
            }
          });

          // return self.removeAllLists(swat);

          if (listsToCreate.length) {
            return self.createLists(swat, listsToCreate);
          }

          self.renderLists(self.currentLists);
          self.updateIconsStatus();
          self.removeList(swat);
        }
      });
    }
    if(!window.SwymCallbacks) {
    window.SwymCallbacks = [];
    }
    window.SwymCallbacks.push(swymCallbackFn);
  }

  updateIconsStatus() {
    const icons = document.querySelectorAll('[data-add-to-lists-button]');
    const yourListsIcons = document.querySelectorAll('[data-your-lists-button]');

    if (this.isListsHasItems.bind(this)()) {
      yourListsIcons?.forEach(icon => icon.classList.add('has-items'));
    } else {
      yourListsIcons?.forEach(icon => icon.classList.remove('has-items'));
    }

    icons?.forEach(icon => {
      const variantId = icon.dataset.epi;
      if (this.isVariantAddedInLists.bind(this)(variantId)) {
        icon.classList.add('added');
      } else {
        icon.classList.remove('added');
      }
    })
  }

  isListsHasItems() {
    let hasItems = false;

    for (let i = 0; i < this.currentLists.length; i++) {
      const listProducts = this.currentLists[i].listcontents;
      if (listProducts && listProducts.length) {
        hasItems = true;
        break;
      }
    }

    return hasItems;
  }

  isVariantAddedInLists(variantId) {
    let isAdded = false;

    for (let i = 0; i < this.currentLists.length; i++) {
      const products = this.currentLists[i].listcontents;
      if (products) {
        for (let j = 0; j < products.length; j++) {
          const product = products[j];
          if (product.epi.toString() === variantId) {
            isAdded = true;
            break;
          }
        }
      }
    }

    return isAdded;
  }

  uncheckAllCheckboxes() {
    const listCheckboxes = this.querySelectorAll('.list-checkbox input[type="checkbox"]');
    listCheckboxes.forEach(checkbox => checkbox.checked = false);
  }

  checkAnyChecked() {
    let isAnyChecked = false;
    const listCheckboxes = this.querySelectorAll('.list-checkbox input[type="checkbox"]');
    listCheckboxes.forEach(checkbox => {
      if (checkbox.checked == true) {
        isAnyChecked = true;
      }
    });
    return isAnyChecked;
  }

  checkList() {
    const listCheckboxes = this.querySelectorAll('.list-checkbox input[type="checkbox"]');
    listCheckboxes.forEach(checkbox => {
      checkbox.addEventListener('change', () => {
        const lid = checkbox.getAttribute('name');
        if (checkbox.checked) {
          this.checkedLists.push(lid);
        } else {
          const index = this.checkedLists.findIndex(item => item === lid);
          this.checkedLists.splice(index, 1);
        }

        const isAnyChecked = this.checkAnyChecked();
        if(isAnyChecked) {
          this.addToListsBtn?.removeAttribute('disabled');
        } else {
          this.addToListsBtn?.setAttribute('disabled', 'disabled');
        }
      })
    })
  }

  removeList(swat) {
    const self = this;
    document.querySelectorAll('[data-delete-list-button]')?.forEach(button => {
      const id = button.dataset.listId;
      button.addEventListener('click', () => {
        const response = confirm("Are you sure to delete this list ?");
        if (response) {
          self.enableLoading(self);
          swat.deleteList(id, function(deletedListObj){
            // successfully deleted list
            console.log("Deleted list id: ", deletedListObj.lid);
            self.updateLists();
          }, function(xhrObject) {
            // something went wrong
          });
        }
      });
    });
  }

  removeAllLists(swat) {
    this.currentLists.forEach(list => {
      swat.deleteList(list.lid, function(deletedListObj){
        // successfully deleted list
        console.log("Deleted list with listid", deletedListObj.lid);
      }, function(xhrObject) {
        // something went wrong
      });
    })
  }

  createLists(swat, listNames) {
    const listsPromises = listNames.map(newListDef => new Promise((resolve, reject) => {
      swat.createList(newListDef, newListObj => {
        resolve(newListObj);
      }, function(xhrObject) {
        // something went wrong
      })
    }))

    Promise.all(listsPromises).then(newLists => {
      this.currentLists = [...this.currentLists, ...newLists];
      this.renderLists(this.currentLists);
    })
  }

  renderAddingProduct(target) {
    const data = target.dataset;
    const productTitle = data.productTitle;
    const productImage = data.productImage;
    this.currentProduct = {
      epi: data.epi,
      empi: data.empi,
      du: data.du
    }

    const html = `
      <div class="lists-adding-product__image">
        <img src="${ productImage }" alt="${ productTitle }" />
      </div>
      <h4 class="lists-adding-product__title">${ productTitle }</h4>`;

    this.productPlaceholder.innerHTML = html;
  }

  renderLists(lists) {
    let html = '';
    const penIcon = this.dataset.penIcon;

    lists?.forEach(list => {
      const amount = list.cnt && list.cnt > 1 ? list.cnt : (list.cnt || 0);
      html += `<div aria-list-name="${ list.lname }" class="list-checkbox">
          <input type="checkbox" id="${ list.lid }" name="${ list.lid }" data-list-name="${ list.lname }" />
          <label for="${ list.lid }">
            <span class="check-icon"></span>
            <span>${ penIcon } ${ list.lname } (${ amount })</span>
          </label>
          <button class="delete-list-button" data-delete-list-button data-list-id="${ list.lid }">
            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="12px" height="14px" viewBox="0 0 12 13" version="1.1">
              <g id="surface1">
                <path style=" stroke:none;fill-rule:nonzero;fill:rgb(0%,0%,0%);fill-opacity:1;" d="M 0 3.65625 L 0 2.769531 C 0.0195312 2.445312 0.152344 2.175781 0.402344 1.957031 C 0.652344 1.734375 0.945312 1.625 1.285156 1.625 L 2.570312 1.625 L 2.570312 1.21875 C 2.570312 0.882812 2.695312 0.59375 2.945312 0.355469 C 3.195312 0.121094 3.5 0 3.855469 0 L 8.140625 0 C 8.5 0 8.804688 0.121094 9.054688 0.355469 C 9.304688 0.59375 9.429688 0.882812 9.429688 1.21875 L 9.429688 1.625 L 10.714844 1.625 C 11.054688 1.625 11.347656 1.734375 11.597656 1.957031 C 11.847656 2.175781 11.980469 2.445312 12 2.769531 L 12 3.65625 C 12 3.875 11.914062 4.066406 11.746094 4.226562 C 11.574219 4.390625 11.375 4.46875 11.140625 4.46875 L 11.140625 11.375 C 11.140625 11.832031 10.976562 12.21875 10.648438 12.53125 C 10.316406 12.84375 9.910156 13 9.429688 13 L 2.570312 13 C 2.089844 13 1.683594 12.84375 1.351562 12.53125 C 1.023438 12.21875 0.855469 11.832031 0.855469 11.375 L 0.855469 4.46875 C 0.625 4.46875 0.425781 4.390625 0.253906 4.226562 C 0.0859375 4.066406 0 3.875 0 3.65625 Z M 0.855469 3.65625 L 11.140625 3.65625 L 11.140625 2.84375 C 11.140625 2.726562 11.101562 2.628906 11.023438 2.550781 C 10.941406 2.476562 10.839844 2.4375 10.714844 2.4375 L 1.285156 2.4375 C 1.160156 2.4375 1.058594 2.476562 0.976562 2.550781 C 0.898438 2.628906 0.855469 2.726562 0.855469 2.84375 Z M 1.714844 11.375 C 1.714844 11.59375 1.800781 11.785156 1.96875 11.945312 C 2.136719 12.105469 2.339844 12.1875 2.570312 12.1875 L 9.429688 12.1875 C 9.660156 12.1875 9.859375 12.105469 10.03125 11.945312 C 10.199219 11.785156 10.285156 11.59375 10.285156 11.375 L 10.285156 4.46875 L 1.714844 4.46875 Z M 2.570312 10.96875 L 2.570312 5.6875 C 2.570312 5.570312 2.613281 5.472656 2.691406 5.394531 C 2.773438 5.320312 2.875 5.28125 3 5.28125 L 3.855469 5.28125 C 3.980469 5.28125 4.085938 5.320312 4.164062 5.394531 C 4.246094 5.472656 4.285156 5.570312 4.285156 5.6875 L 4.285156 10.96875 C 4.285156 11.085938 4.246094 11.183594 4.164062 11.261719 C 4.085938 11.335938 3.980469 11.375 3.855469 11.375 L 3 11.375 C 2.875 11.375 2.773438 11.335938 2.691406 11.261719 C 2.613281 11.183594 2.570312 11.085938 2.570312 10.96875 Z M 3 10.96875 L 3.855469 10.96875 L 3.855469 5.6875 L 3 5.6875 Z M 3.429688 1.625 L 8.570312 1.625 L 8.570312 1.21875 C 8.570312 1.101562 8.53125 1.003906 8.449219 0.925781 C 8.371094 0.851562 8.265625 0.8125 8.140625 0.8125 L 3.855469 0.8125 C 3.730469 0.8125 3.628906 0.851562 3.550781 0.925781 C 3.46875 1.003906 3.429688 1.101562 3.429688 1.21875 Z M 5.140625 10.96875 L 5.140625 5.6875 C 5.140625 5.570312 5.183594 5.472656 5.261719 5.394531 C 5.34375 5.320312 5.445312 5.28125 5.570312 5.28125 L 6.429688 5.28125 C 6.554688 5.28125 6.65625 5.320312 6.734375 5.394531 C 6.816406 5.472656 6.855469 5.570312 6.855469 5.6875 L 6.855469 10.96875 C 6.855469 11.085938 6.816406 11.183594 6.734375 11.261719 C 6.65625 11.335938 6.554688 11.375 6.429688 11.375 L 5.570312 11.375 C 5.445312 11.375 5.34375 11.335938 5.261719 11.261719 C 5.183594 11.183594 5.140625 11.085938 5.140625 10.96875 Z M 5.570312 10.96875 L 6.429688 10.96875 L 6.429688 5.6875 L 5.570312 5.6875 Z M 7.714844 10.96875 L 7.714844 5.6875 C 7.714844 5.570312 7.753906 5.472656 7.835938 5.394531 C 7.914062 5.320312 8.015625 5.28125 8.140625 5.28125 L 9 5.28125 C 9.125 5.28125 9.226562 5.320312 9.308594 5.394531 C 9.386719 5.472656 9.429688 5.570312 9.429688 5.6875 L 9.429688 10.96875 C 9.429688 11.085938 9.386719 11.183594 9.308594 11.261719 C 9.226562 11.335938 9.125 11.375 9 11.375 L 8.140625 11.375 C 8.015625 11.375 7.914062 11.335938 7.835938 11.261719 C 7.753906 11.183594 7.714844 11.085938 7.714844 10.96875 Z M 8.140625 10.96875 L 9 10.96875 L 9 5.6875 L 8.140625 5.6875 Z M 8.140625 10.96875 "/>
              </g>
            </svg>
          </button>
        </div>`
    });

    this.listsPlaceholder.innerHTML = html;
    this.checkList();
    this.disableLoading(this);
  }

  open(target) {
    this.renderAddingProduct.bind(this)(target);
    this.classList.add('active');
  }

  close() {
    this.classList.remove('active');
  }

  enableLoading(container) {
    container.querySelector('.loading-state').classList.remove('hidden');
  }

  disableLoading(container) {
    container.querySelector('.loading-state').classList.add('hidden');
  }
}
